function handleSetDimensions(draft, action) {
    const { width, height } = action.payload;
    draft.width = width;
    draft.height = height;
}
export { handleSetDimensions };
